import { render } from "./goldSmith.vue?vue&type=template&id=6d6c2064&lang=true"
import script from "./goldSmith.vue?vue&type=script&lang=js"
export * from "./goldSmith.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__